<template>
	<!-- 工作台 -->
	<div class="mod-config">
		<el-row style="margin-top: -5px;">
			<el-col :span="16">
				<el-card class="project-info-card fixed-height-card">
					<div slot="header" class="bd card-header">
						项目信息
					</div>
					<el-form :model="infoName" ref="infoName" label-width="110px" :inline="true"
						class="border-form compact-form">
						<el-row class="set_border">
							<el-col :span="10" class="col-set_border">
								<el-form-item label="工作控制号" class="item">
									<div class="text-truncate" :title="infoName.workNo">{{ infoName.workNo }}</div>
								</el-form-item>
							</el-col>
							<el-col :span="14">
								<el-form-item label="项目名称" class="item">
									<div class="text-truncate" :title="infoName.projectName">{{ infoName.projectName }}
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row class="set_border">
							<el-col :span="10" class="col-set_border">
								<el-form-item label="委托单位" class="item">
									<div class="text-truncate" :title="infoName.projectEntrust">{{
										infoName.projectEntrust }}</div>
								</el-form-item>
							</el-col>
							<el-col :span="14">
								<el-form-item label="承包单位" class="item">
									<div class="text-truncate" :title="infoName.contractCompany">{{
										infoName.contractCompany }}</div>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row class="set_border">
							<el-col :span="10" class="col-set_border">
								<el-form-item label="设计单位" class="item">
									<div class="text-truncate" :title="infoName.projectDesignCompany">{{
										infoName.projectDesignCompany }}</div>
								</el-form-item>
							</el-col>
							<el-col :span="14">
								<el-form-item label="建造单位" class="item">
									<div class="text-truncate" :title="infoName.projectConstructionCompany">{{
										infoName.projectConstructionCompany }}</div>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row class="set_border">
							<el-col :span="10" class="col-set_border">
								<el-form-item label="开工时间" class="item">
									<div class="text-truncate" :title="infoName.projectBeginTime">{{
										infoName.projectBeginTime }}</div>
								</el-form-item>
							</el-col>
							<el-col :span="14">
								<el-form-item label="完工时间" class="item">
									<div class="text-truncate" :title="infoName.projectFinishTime">{{
										infoName.projectFinishTime }}</div>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-card>
			</el-col>
			<el-col :span="4">
				<el-card class="person-card fixed-height-card" style="margin-left: 10px;">
					<div slot="header" class="bd card-header">
						项目负责人
						<i class="el-icon-d-arrow-right" style="float:right" @click="showMorePerson()"></i>
					</div>
					<div class="scroll-content fixed-scroll-content">
						<div style="margin-left: 20px; margin-bottom: 10px;">
							<span>项目总监</span>
							<span style="margin-left: 30px;">{{ infoName.projectDirector }}</span>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="4">
				<el-card class="subject-card fixed-height-card" style="margin-left: 10px;">
					<div slot="header" class="bd card-header">
						标的物
						<i class="el-icon-d-arrow-right" style="float:right" @click="showMoreSubject()"></i>
					</div>
					<div class="scroll-content fixed-scroll-content">
						<div class="subject-item" v-for="(item, index) in subjectList" :key="'nav' + index">
							<span class="project-no text-truncate" :title="item.projectNo">【{{ item.projectNo }}】{{
								item.displayName
							}}</span>
							<!-- <span class="display-name text-truncate" :title="item.displayName">{{ item.displayName
							}}</span> -->
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>
		<el-row style="margin-top: 10px;">
			<el-card class="compact-card">
				<div slot="header" class="bd card-header-compact">
					<div class="header-content">
						<span class="header-title">项目当前所处阶段</span>
						<div class="stage-header">
							<span class="stage-name">{{ getStageName(infoName.projectStep) }}</span>
							<el-button v-if="infoName.isProjectManager == 1" type="text" @click="handleSetting"
								class="stage-setting-btn">
								设置
							</el-button>
						</div>
					</div>
				</div>
				<el-row class="compact-content">
					<!-- 阶段进度条 -->
					<div class="stage-progress-container">
						<div class="stage-progress">
							<div v-for="(stage, index) in stageList" :key="stage.code" :class="[
								'stage-node',
								getStageClass(stage.code)
							]" @click="handleStageClick(stage.code)">
								<!-- 阶段序号和状态 -->
								<div class="node-marker">
									<div class="marker-circle" :class="getStageClass(stage.code)">
										<svg v-if="getStageClass(stage.code) === 'stage-past'" class="icon-check"
											viewBox="0 0 24 24">
											<path fill="currentColor"
												d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
										</svg>
										<span v-else class="marker-number">{{ index + 1 }}</span>
									</div>
									<!-- 连接线 -->
									<div v-if="index < stageList.length - 1" class="connector"
										:class="getConnectorClass(stage.code, stageList[index + 1].code)"></div>
								</div>

								<!-- 阶段名称 -->
								<div class="node-label" :class="getStageClass(stage.code)">
									{{ stage.name }}
								</div>
							</div>
						</div>

						<!-- 灰色背景线 -->
						<div class="grey-background-line"></div>

						<!-- 蓝色进度线 - 使用更简单的计算方式 -->
						<div class="blue-progress-line" :style="{ width: getSimpleBlueWidth() }"></div>
					</div>

					<!-- 阶段详情 -->
					<div class="stage-content" :class="{ 'last-stage-detail': true }">
						<!-- 记录与归档及移交阶段特殊布局 -->
						<template v-if="selectedDisplayStep === '06'">
							<div class="archiving-section">
								<div class="file-kind-row">
									<span class="file-kind-name-compact">记录与归档及移交</span>
									<span class="file-records">
										按照附表"监理资料交接清单"完成，清单模版从"
										<span class="hand_menu" @click="jumpToTemplate()">程序文件模版库</span>
										"下载
									</span>
								</div>
								<div class="archiving-content">
									<div class="archiving-form">
										<div class="form-row">
											<el-button v-preventReClick type="text"
												:disabled="infoName.handoverFilePath == '' || infoName.handoverFilePath == undefined"
												@click="viewPdf(infoName.handoverFilePath, infoName.handoverFilePathUri, '监理资料交接清单')">监理资料交接清单</el-button>
										</div>
										<!-- <div class="form-row">
											<el-button v-preventReClick type="text" size="small"
												style="font-size: 14px;"
												v-if="infoName.filingFileUri != null && infoName.filingFileUri != ''"
												@click="viewPdf(infoName.filingFile, infoName.filingFileUri, '卷内目录清单')">卷内目录清单</el-button>
										</div>
										<div class="form-row" style="margin-left: 60px;">
											<div class="form-label">立卷归档时间</div>
											<div class="form-value"
												v-if="infoName.filingTime == '' || infoName.filingTime == null">--</div>
											<div class="form-value" v-else>{{ infoName.filingTime }}</div>
										</div>

										<div class="form-row" style="margin-left: 60px;">
											<div class="form-label">立卷归档人</div>
											<div class="form-value"
												v-if="infoName.filingMan == '' || infoName.filingMan == null">--</div>
											<div class="form-value" v-else>{{ infoName.filingMan }}</div>
										</div>

										<div class="form-row" style="margin-left: 60px;">
											<div class="form-label">立卷归档状态</div>
											<div class="form-value">
												<span class="status-tag status-unarchived"
													v-if="infoName.filingTime != null && infoName.filingTime != ''">已归档</span>
												<span class="status-tag status-unarchived" v-else>未归档</span>
											</div>
										</div>

										<div class="form-row">
											<el-button v-preventReClick type="text" size="small"
												style="font-size: 14px;"
												@click="downloadTemplate()">卷内目录清单模版下载</el-button>
											<el-button v-preventReClick type="text" size="small"
												style="font-size: 14px; margin-left: 70px;"
												@click="projectArchiveHandle()">项目归档</el-button>
										</div> -->
									</div>
								</div>
							</div>
						</template>

						<template v-else>
							<!-- 阶段内容 -->
							<div v-for="item in currentStageItems" :key="item.recno" class="archiving-section">
								<div class="file-kind-row">
									<span class="file-kind-name-compact">{{ item.stepName }}</span>
									<span class="file-records" v-if="item.stepCode == '01'">
										{{ getFileRecords(item.records) }}
									</span>
									<span class="file-records" v-if="item.stepCode == '02'">
										对被监理单位建造准备工作的检查
									</span>
									<span class="file-records" v-if="item.stepCode == '03'">
										对船舶建造开展的质量控制、进度控制、投资控制、HSE管理、信息管理、组织协调等工作
									</span>
									<span class="file-records" v-if="item.stepCode == '04'">
										包括船舶实体验收、交船资料审查、见证备品备件交接、督促培训事宜的落实等
									</span>
									<span class="file-records" v-if="item.stepCode == '05'">
										船舶建造完工、交船后，合同约定的船舶质保期内的监理售后保障服务工作
									</span>
									<span class="file-records" v-if="item.stepCode == '06'">
										按照附表"卷内目录清单"完成项目立卷归档工作
									</span>
								</div>

								<!-- 详细记录 -->
								<div v-for="record in item.records" :key="record.recno" class="record-row">
									<span class="record-name">{{ record.filekindName }}</span>
									<div class="subclass-list" v-if="record.subList && record.subList.length > 0">
										<span v-for="sub in record.subList" :key="sub.recno"
											:class="getSubclassClass(sub)" @click="handleSubclassClick(sub)">
											{{ sub.subclassname }}
										</span>
									</div>
								</div>
							</div>
						</template>
					</div>
				</el-row>
			</el-card>
		</el-row>

		<el-row style="margin-top: -5px;" class="workbench-row">
			<el-col :span="17">
				<el-card class="set_card project-work-card">
					<div slot="header" class="bd">项目相关工作</div>
					<el-row :gutter="0" class="project-work-content">
						<el-col :span="2" v-for="(item, index) in projectWorkItems" :key="index" class="work-item">
							<div class="roundBox" :class="`roundBox0${item.colorIndex}`">
								<div @click="item.clickHandler">{{ infoCount[item.dataKey] || 0 }}</div>
							</div>
							<div class="roundText">{{ item.label }}</div>
						</el-col>
					</el-row>
				</el-card>
			</el-col>
			<el-col :span="7">
				<el-card class="unclosed-work-card" style="margin-left: 10px;">
					<div slot="header" class="bd">未封闭工作</div>
					<el-row class="unclosed-work-content">
						<el-col :span="8" v-for="(item, index) in unclosedWorkItems" :key="index" class="unclosed-item">
							<div class="roundBox" :class="`roundBox0${item.colorIndex}`">
								<div @click="item.clickHandler">{{ noCloseCount[item.dataKey] || 0 }}</div>
							</div>
							<div class="roundText">{{ item.label }}</div>
						</el-col>
					</el-row>
				</el-card>
			</el-col>
		</el-row>
		<el-row style="margin-top: 10px;">
			<el-col :span="24">
				<el-card class="">
					<div slot="header" class="bd">进度节点
						<i class="el-icon-d-arrow-right" style="float:right;margin-top:5px" @click="showMoreNode()"></i>
					</div>
					<!-- <div class="node-container" v-for="(node) in nodeList" style="margin-top: 10px;">
						<div class="node-left-container">{{ node.projectNo }}</div>
						<div class="node-right-container">
							<div class="node-right-container-row">
								<div class="node-content-title1">日期</div>
								<div class="node-content-body1" v-for="(item, index) in node.dataDate" v-if="index < node.dataDate.length - 1">{{ item }}</div>
								<div class="node-content-body4" v-for="(item, index) in node.dataDate" v-if="index == node.dataDate.length - 1">{{ item }}</div>
							</div>
							<div class="node-right-container-row">
								<div class="node-content-title2">计划</div>
								<div class="node-content-body" v-for="(item, index) in node.dataPlan" v-if="index < node.dataPlan.length - 1">{{ item }}</div>
								<div class="node-content-body5" v-for="(item, index) in node.dataPlan" v-if="index == node.dataPlan.length - 1">{{ item }}</div>
							</div>
							<div class="node-right-container-row" v-if="node.dataChange.length > 0">
								<div class="node-content-title-container">
									<div class="node-content-title-container-left">
										变更
									</div>
									<div class="node-content-title-container-right">
										<div class="node-content-title-container-right-row"
											v-for="(item) in node.dataChange">
											<div class="node-content-body" v-for="(item2, index) in item" v-if="index < item.length - 1">{{ item2 }}</div>
											<div class="node-content-body5" v-for="(item2, index) in item" v-if="index == item.length - 1">{{ item2 }}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="node-right-container-row">
								<div class="node-content-title3">实际</div>
								<div class="node-content-body3" v-for="(item, index) in node.dataTime" v-if="index < node.dataTime.length - 1">{{ item }}</div>
								<div class="node-content-body6" v-for="(item, index) in node.dataTime" v-if="index == node.dataTime.length - 1">{{ item }}</div>
							</div>
						</div>
					</div> -->
					<el-table max-height="600" :row-class-name="tableRowClassName" :span-method="objectSpanMethod"
						ref="dataListTable" class="dataListTable1" border :data="nodeList" header-align="center"
						header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px', fontSize: '13px' }"
						:header-cell-style="{ padding: '0px', fontSize: '13px' }">
						<el-table-column v-for="(v, idx) in headers" :key="idx"
							v-if="headers != undefined && headers.length > 0 && v.nodeId === '0'" :label="v.nodeName"
							:prop="v.nodeId" align="center" width="130px">
							<template slot-scope="scope">
								<span style="font-weight:bolder">
									{{ scope.row.subjectName }}
								</span>
							</template>
						</el-table-column>
						<el-table-column v-for="(v, idx) in headers" :key="idx"
							v-if="headers != undefined && headers.length > 0 && v.nodeId === '1'" :label="v.nodeName"
							:prop="v.nodeId" align="center" width="60px">
							<template slot-scope="scope">
								<span style="font-weight:bolder">
									{{ scope.row.title }}
								</span>
							</template>
						</el-table-column>
						<el-table-column v-for="(v, idx) in headers" :key="idx"
							v-if="headers != undefined && headers.length > 0 && idx > 1" :label="v.nodeName"
							:prop="v.nodeId" align="center">
							<template slot-scope="scope">
								<span>
									{{ scope.row.contentList[idx - 2].colValue }}
								</span>
							</template>
						</el-table-column>
						<el-table-column align="left" label="" v-if="headers != undefined && headers.length == 2">
						</el-table-column>
					</el-table>
				</el-card>
			</el-col>
		</el-row>
		<el-row style="margin-top: 10px;">
			<el-col :span="11">
				<el-card class="">
					<div slot="header" class="bd">质量巡检整改</div>
					<el-row style="margin-top: -15px;">
						<el-row v-for="(inspection, index) in inspectionList" v-model="inspectionList"
							:key="'ins' + index">
							<el-col :span="24" style="font-weight: bolder;font-size: 16px;margin: 5px;"> {{
								inspection.projectNo }}</el-col>
							<el-col :span="24">
								<el-table ref="workbenchList" class="workbenchList" :data="inspection.detailDtoList"
									header-align="center" :cell-style="{ padding: '0px', fontSize: '13px' }"
									:header-cell-style="{ padding: '0px', fontSize: '13px' }"
									header-cell-class-name="dataListTHeader">
									<el-table-column label="专业" prop="majorName" width="" align="center">
									</el-table-column>
									<el-table-column label="提出整改项" prop="applyNum" width="" align="center">
									</el-table-column>
									<el-table-column label="整改完成项" prop="alreadyModifyNum" width="" align="center">
									</el-table-column>
									<el-table-column label="未完成项" prop="notFinishNum" width="" align="center">
										<template slot-scope="scope">
											<div style="color: red;"> {{ scope.row.notFinishNum }}</div>
										</template>
									</el-table-column>
									<el-table-column label="完成率" prop="finishRate" width="" align="center">
									</el-table-column>
								</el-table>
							</el-col>
						</el-row>
					</el-row>
				</el-card>
			</el-col>
			<el-col :span="13">
				<el-card class="" style="margin-left: 10px;">
					<div slot="header" class="bd">质量报验</div>
					<el-row style="margin-top: -15px;">
						<el-row v-for="(testrecord, index) in testRecordList" v-model="testRecordList"
							:key="'test' + index">
							<el-col :span="24" style="font-weight: bolder;font-size: 16px;margin: 5px;"> {{
								testrecord.projectNo }}</el-col>
							<el-col :span="24">
								<el-table ref="workbenchList" class="workbenchList" :data="testrecord.detailDtoList"
									header-align="center" :cell-style="{ padding: '0px', fontSize: '13px' }"
									:header-cell-style="{ padding: '0px', fontSize: '13px' }"
									header-cell-class-name="dataListTHeader">
									<el-table-column label="专业" prop="majorName" width="" align="center">
									</el-table-column>
									<el-table-column label="报验" prop="testRecordNum" width="" align="center">
									</el-table-column>
									<el-table-column label="接受" prop="testConclusionNum" width="" align="center">
									</el-table-column>
									<el-table-column label="有条件接受" prop="testConclusionWhereNum" width=""
										align="center">
									</el-table-column>
									<el-table-column label="修正后复检" prop="recheckAfterCorrectionNum" width=""
										align="center">
									</el-table-column>
									<el-table-column label="不接受" prop="testConclusionRefuseNum" width="" align="center">
									</el-table-column>
									<el-table-column label="合格率" prop="testConclusionRate" width="" align="center">
									</el-table-column>
								</el-table>
							</el-col>
						</el-row>
					</el-row>
				</el-card>
			</el-col>
		</el-row>

		<el-dialog :title="subClassTitle" :close-on-click-modal="false" :visible.sync="subClassVisible"
			top="calc(5vh - 40px)" class="compact-dialog" @close="handleDialogClose">
			<el-row class="dialog-content">
				<el-table :row-class-name="tableRowClassName" ref="dataListTable" class="dataListTable"
					:data="projectFileDetailList" header-align="center" :max-height="tableMaxHeight"
					style="width: 100%; margin-top: 0px;" header-cell-class-name="dataListTHeader"
					:cell-style="{ padding: '3px 0' }" :show-header="false">
					<el-table-column type="index" label="NO." width="60" align="center">
						<template slot-scope="scope">{{ (pageIndex2 - 1) * pageSize + scope.$index + 1 }}</template>
					</el-table-column>
					<el-table-column prop="fileName" label="文件名称" header-align="center" align="left"
						show-overflow-tooltip>
						<template slot-scope="scope">
							<el-button v-preventReClick type="text" size="small" style="font-size: 12px; padding: 0;"
								@click="viewPdf(scope.row.filePath, scope.row.fileUri, scope.row.fileName)">{{
									scope.row.fileName }}</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="uploadMan" label="报告人" width="80" align="center">
						<template slot-scope="scope">
							<span style="font-size: 12px;">{{ scope.row.uploadMan }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="uploadTime" label="报告时间" width="120" align="center">
						<template slot-scope="scope">
							<span style="font-size: 12px;">{{ scope.row.uploadTime }}</span>
						</template>
					</el-table-column>
					<el-table-column width="150" align="center">
						<template slot-scope="scope">
							<el-button v-preventReClick type="text" size="small" style="font-size: 12px; padding: 0;"
								@click="downLoadFile(scope.row.fileUri, scope.row.fileName)">下载</el-button>
							<el-button v-preventReClick type="text" size="mini" @click="addProjectHandOver(scope.row)"
								v-if="scope.row.fileUri">加入档案交接清单</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div style="width: 106%;height: 1px;background: rgb(237 231 231);margin-left: -20px;margin-top: -1px;">
				</div>
				<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
					@current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]"
					:page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
				</el-pagination>
			</el-row>
		</el-dialog>

		<el-dialog title="项目当前阶段" :close-on-click-modal="false" :visible.sync="setStepVisible" width="400px"
			@close="handleDialogClose">
			<el-row class="set_border">
				<el-col :span="8">
					<div class="majTitle1" style="">项目当前阶段</div>
				</el-col>
				<el-col :span="15" style="margin-left: 5px;">
					<el-select v-model="tempProjectStep" placeholder="请选择" class="selSubjectInput">
						<el-option v-for="item in stepList" :key="item.code" :label="item.name" :value="item.code">
						</el-option>
					</el-select>
				</el-col>
			</el-row>
			<el-row style="margin-top: 10px;text-align: center;">
				<el-col :span="24">
					<el-button v-preventReClick class="btn" type="primary" size="small"
						@click="saveProjectStepHandle()">保存</el-button>
				</el-col>
			</el-row>
		</el-dialog>

		<!-- <el-dialog title="项目归档" :close-on-click-modal="false" :visible.sync="projectArchiveVisible" width="650px"
			@close="handleDialogClose">
			<el-row>
				<span class="upload-header">立卷归档清单上传</span>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-upload v-if="!archiveData.filingFile" ref="uploadFilingFile" class="upload-demo" action="action"
						drag :http-request="uploadFilingFile" :show-file-list=false :auto-upload="true">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					</el-upload>
					<div v-if="archiveData.filingFile" style="margin-left: 0px;margin-top: 30px;">
						<el-button v-preventReClick type="text" size="small" style="font-size: 14px;"
							@click="viewPdf(archiveData.filingFile, archiveData.filingFileUri, '立卷归档清单')">查看</el-button>
						<el-button v-preventReClick type="text" size="small" style="font-size: 14px;"
							@click="delFilingFile()">删除</el-button>
					</div>
				</el-col>
			</el-row>
			<el-row style="margin-top: 30px;">
				<el-col :span="12">
					<span class="upload-header">立卷归档时间</span>
					<el-date-picker style="margin-left: 10px; width: 150px;padding: 0;" v-model="archiveData.filingTime"
						type="date" value-format="yyyy-MM-dd" placeholder=""></el-date-picker>
				</el-col>
				<el-col :span="12">
					<span class="upload-header">立卷归档人</span>
					<el-input v-model="archiveData.filingMan" style="width: 150px;margin-left: 10px;"
						class="custom-input"></el-input>
				</el-col>
			</el-row>
			<el-row style="margin-top: 10px;text-align: center;">
				<el-col :span="24">
					<el-button v-preventReClick class="btn" type="primary" size="small" style="margin-top: 10px;"
						:disabled="archiveData.filingFile == '' || archiveData.filingFile == null"
						@click="saveProjectFilingFileHandle()">归档</el-button>
				</el-col>
			</el-row>
		</el-dialog> -->

		<project-kind-setting v-if="projectKindSettingVisible" ref="projectKindSetting"
			@refreshDataList="getInfoName()"></project-kind-setting>
		<handover-list v-if="projectHandoverVisible" ref="handoverList"></handover-list>
		<view-pdf v-if="viewPdfVisible" ref="viewPdf"></view-pdf>
	</div>
</template>

<script>
import $common from "@/utils/common.js"
import ProjectKindSetting from './project-kind-setting'
import HandoverList from './project-handover-list.vue'
import ViewPdf from "../projectInfo/viewPdf.vue"
export default {
	data() {
		return {
			showNodeMore: false,
			showPersonMore: false,
			showPersonSet: false,
			infoList: [],
			noCloseCount: {},
			infoCount: {},
			infoName: {},
			infoRemind: {},
			category: {},
			jobList: [],
			inspectorInfo: {},
			setingPersonVisible: false,
			projectKindSettingVisible: false,
			helpFileUrl: 'http://cs.ccsi.com.cn/upload/help/helpFile.pdf',
			menuList: [],
			subjectList: [],
			inspectionList: [],
			testRecordList: [],
			nodeList: [],
			headers: [],
			projectFilekindList: [],
			infoName: {},
			projectFileDetailList: [],
			subjectList: [],
			//当前页码
			pageIndex: 1,
			// 显示序号
			pageIndex2: 1,
			//当前记录数
			pageSize: 20,
			//总页数
			totalPage: 0,
			setStepVisible: false,
			projectHandoverVisible: false,
			subClassVisible: false,
			viewPdfVisible: false,
			projectArchiveVisible: false,
			subClassTitle: '',
			selectSubclasscode: '',
			tempProjectStep: '', // 临时存储设置的项目阶段
			selectedDisplayStep: '01', // 当前选中的显示阶段（与infoName.projectStep无关）
			stageList: [
				{ code: '01', name: '1 前期准备' },
				{ code: '02', name: '2 建造开工准备' },
				{ code: '03', name: '3 建造期' },
				{ code: '04', name: '4 交船验收期' },
				{ code: '05', name: '5 质保期' },
				{ code: '06', name: '6 记录与归档及移交' }
			],
			stepList: [
				{ code: '01', name: '前期准备' },
				{ code: '02', name: '建造开工准备' },
				{ code: '03', name: '建造期' },
				{ code: '04', name: '交船验收期' },
				{ code: '05', name: '质保期' },
				{ code: '06', name: '记录与归档及移交' }
			],
			// archiveData: {
			// 	filingFile: '',
			// 	filingMan: '',
			// 	filingTime: '',
			// 	filingFileUri: ''
			// },
			// 系统保留的子类型编码列表
			specialSubclasscodeList: [
				'010101', // 监理/建造合同
				'010102', // 技术方案/标书
				'010103', // 合同评审意见书
				'010301', // 监理规划
				'010302', // 监理实施细则
			],
			tableMaxHeight: 580, // 动态计算表格最大高度
			// 项目相关工作项配置
			projectWorkItems: [
				{ label: '巡检', dataKey: 'problemSource', colorIndex: 1, clickHandler: this.moreInspection },
				{ label: '报验', dataKey: 'problemState', colorIndex: 7, clickHandler: this.moreInformation },
				{ label: '旁站', dataKey: 'monitor', colorIndex: 5, clickHandler: this.moreStation },
				{ label: '联系单', dataKey: 'contact', colorIndex: 6, clickHandler: this.moreContact },
				{ label: '通知单', dataKey: 'notice', colorIndex: 3, clickHandler: this.moreNotice },
				{ label: '周报', dataKey: 'week', colorIndex: 1, clickHandler: this.moreWeekly },
				{ label: '月报', dataKey: 'month', colorIndex: 2, clickHandler: this.moreMonthly },
				{ label: '专题报告', dataKey: 'specialReport', colorIndex: 3, clickHandler: this.moreSpecialReport },
				{ label: '会议', dataKey: 'meet', colorIndex: 4, clickHandler: this.moreMeet },
				{ label: '文件审查', dataKey: 'exa', colorIndex: 7, clickHandler: this.moreExamination }
			],
			// 未封闭工作项配置
			unclosedWorkItems: [
				{ label: '巡视', dataKey: 'problemSource', colorIndex: 1, clickHandler: this.moreInspection },
				{ label: '报验', dataKey: 'problemState', colorIndex: 2, clickHandler: this.moreInformation },
				{ label: '监理通知单', dataKey: 'notice', colorIndex: 4, clickHandler: this.moreNotice }
			],
			// 每个阶段对应的蓝色线宽度百分比
			stageWidths: {
				'01': '8%',   // 第一阶段
				'02': '25%',  // 第二阶段
				'03': '42%',  // 第三阶段
				'04': '59%',  // 第四阶段
				'05': '76%',  // 第五阶段
				'06': '100%'  // 第六阶段
			},
			handoverFilePath: '',
			handoverFilePathUri: ''
		};
	},
	components: {
		ProjectKindSetting,
		ViewPdf,
		HandoverList
	},
	computed: {
		// 获取当前显示阶段的文件种类列表（与infoName.projectStep无关）
		currentStageItems() {
			if (!this.projectFilekindList.length) {
				return [];
			}
			return this.projectFilekindList.filter(item =>
				item.stepCode === this.selectedDisplayStep
			);
		}
	},
	mounted() {
		this.menuList = $common.getItem("menuList")
		this.workNo = $common.getItem("workNo")
		this.getSubjectDropDown()
		this.getInfoName();
		this.getProjectFileKindList();
		// 计算表格最大高度
		this.calculateTableMaxHeight();
	},
	methods: {
		getProjectKind(kind) {
			if (kind === '1') {
				return '船舶监理'
			} else if (kind === '2') {
				return '设备监理'
			}
			return ''
		},
		// 计算表格最大高度
		calculateTableMaxHeight() {
			this.tableMaxHeight = 692 - 40 - 32 - 55;
		},
		getSubjectDropDown() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getSubjectDropDown/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.subjectList = data.body || [];
					// 最多只显示4条
					if (this.subjectList.length > 4) {
						this.subjectList = this.subjectList.slice(0, 4);
					}

					this.$store.commit('common/updateSubjectList', this.subjectList)
					if (this.subjectList.length != undefined && this.subjectList.length > 0) {
						if ($common.getItem("subjectNo") == "" || $common.getItem("subjectNo") == undefined) {
							$common.setItem("subjectNo", this.subjectList[0].displayValue);
							this.$store.commit('common/updateSelectSubjectNo', this.subjectNo)
						}
					}
					this.$emit('subMenuIndex', 0)
					this.showNodeMore = $common.isAuth('workbench:node.more');
					this.showPersonMore = $common.isAuth('workbench:person.more');
					this.showPersonSet = $common.isAuth('workbench:person.set');
					// this.getInfo();
					this.getInfoCount();
					this.getInfoName();
					this.getInfoRemind();
					this.selectCategory();
					this.selectJob();
					this.getNoCloseCount();
					this.getTestRecordList();
					this.getInspectionList();
					this.refreshNodeRecords();
					// this.getNodeInfoList();
				}
				// }
			});
		},
		getSubjectMenuIndex() {
			let rtn = 0
			this.menuList[0].list.forEach(function (item, idx) {
				if (item.routerName === '/subjectList') {
					rtn = idx
				}
			})
			return rtn
		},
		showHelpFile() {
			window.open(this.helpFileUrl);
		},
		siteContentViewHeight() {
			var height = this.$store.state.common.documentClientHeight - 50;
			return { height: height + 'px' }
		},
		projectUserListHeight() {
			var height = this.$store.state.common.documentClientHeight - 670;
			return { height: height + 'px' }
		},
		settingProjectKind() {
			this.projectKindSettingVisible = true
			this.$nextTick(() => {
				this.$refs.projectKindSetting.init()
			})
		},
		setingPersonHandle(id) {
			this.setingPersonVisible = true
			this.$nextTick(() => {
				this.$refs.setingPerson.init(id);
			})
		},
		goPage(type) {
			let _indexList = [];
			if (type == 1) {
				this.$router.push("/nodeList");
				_indexList = $common.getMenuIndex("/nodeList");
			} else {
				this.$router.push("/personnelCommun");
				_indexList = $common.getMenuIndex("/personnelCommun");
			}
			this.$parent.setMenuAllIndex(_indexList[0], _indexList[1]);
		},
		getNoCloseCount() {
			this.$http({
				url: this.$store.state.httpUrl + "/index/noCloseCount/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.noCloseCount = data.body;
				}
			});
		},
		getInspectionList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/inspectioninfo/getInspectionList/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.inspectionList = data.body;
				}
			});
		},
		getTestRecordList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/testrecord/getTestRecordList/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.testRecordList = data.body;
				}
			});
		},
		refreshNodeRecords() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectprogressnoderecord/refreshNodeRecords/" + $common.getItem("workNo"),
				method: 'post',
				params: this.$http.adornParams({
				})
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.getNodeInfoList();
				}
			})
		},
		// 获取进度节点数据
		getNodeInfoList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectprogressnoderecord/list/" + $common.getItem("workNo"),
				method: 'get',
				params: this.$http.adornParams({
				})
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.nodeList = data.body.records;
					this.headers = data.body.headers;
				}
			})
		},
		getInfoCount() {
			this.$http({
				url: this.$store.state.httpUrl + "/index/infoCount/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.infoCount = data.body;
				}
			});
		},
		getInfoRemind() {
			this.$http({
				url: this.$store.state.httpUrl + "/index/infoRemind/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.infoRemind = data.body;
				}
			});
		},
		selectCategory() {
			this.$http({
				url: this.$store.state.httpUrl + "/index/selectCategory?workNo=" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.category = data.body;
				}
			});
		},
		selectJob() {
			this.$http({
				url: this.$store.state.httpUrl + "/index/selectJob?workNo=" + $common.getItem("workNo"),
				method: "POST",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.jobList = data.body.personList;
					this.inspectorInfo = data.body.inspectorInfo;
				}
			});
		},
		showMoreSubject() {
			sessionStorage.setItem('menuIndex', 0)
			sessionStorage.setItem('subMenuIndex', 2)
			sessionStorage.setItem('sessionFlg', true)
			sessionStorage.setItem('sessionFlg2', true)
			this.$cookie.set('showSidebarFlag', false)
			this.$router.push({ name: 'subjectList' });
		},
		showMorePerson() {
			sessionStorage.setItem('menuIndex', 0)
			sessionStorage.setItem('subMenuIndex', 1)
			sessionStorage.setItem('sessionFlg', true)
			sessionStorage.setItem('sessionFlg2', true)
			this.$cookie.set('showSidebarFlag', false)
			this.$router.push({ name: 'personnelCommun' });
		},
		showMoreNode() {
			sessionStorage.setItem('menuIndex', 3)
			sessionStorage.setItem('subMenuIndex', 2)
			sessionStorage.setItem('sessionFlg', true)
			sessionStorage.setItem('sessionFlg2', true)
			this.$cookie.set('showSidebarFlag', false)
			this.$router.push({ name: 'projectProgressRecordList' });
		},
		moreInspection() {
			sessionStorage.setItem('menuIndex', 1)
			sessionStorage.setItem('subMenuIndex', 0)
			sessionStorage.setItem('sessionFlg', true)
			sessionStorage.setItem('sessionFlg2', true)
			this.$cookie.set('showSidebarFlag', false)
			this.$router.push({ name: 'patrolList', query: { type: 1 } });
		},
		moreInformation() {
			sessionStorage.setItem('menuIndex', 1)
			sessionStorage.setItem('subMenuIndex', 1)
			sessionStorage.setItem('sessionFlg', true)
			sessionStorage.setItem('sessionFlg2', true)
			this.$cookie.set('showSidebarFlag', false)
			this.$router.push({ name: 'information', query: { type: 1 } });
		},
		moreContact() {
			sessionStorage.setItem('menuIndex', 6)
			sessionStorage.setItem('subMenuIndex', 2)
			sessionStorage.setItem('sessionFlg', true)
			sessionStorage.setItem('sessionFlg2', true)
			this.$cookie.set('showSidebarFlag', false)
			if (this.infoName.executedFile === '1') {
				// 上海
				this.$router.push({ name: 'contactdocument', query: { type: '01' } });
			} else {
				// ccsi
				this.$router.push({ name: 'hqcontact', query: { type: '01' } });
			}
		},
		moreSpecialReport() {
			sessionStorage.setItem('menuIndex', 6)
			if (this.infoName.executedFile === '1') {
				// 上海
				sessionStorage.setItem('subMenuIndex', 9)
			} else {
				// ccsi
				sessionStorage.setItem('subMenuIndex', 8)
			}
			sessionStorage.setItem('sessionFlg', true)
			sessionStorage.setItem('sessionFlg2', true)
			this.$cookie.set('showSidebarFlag', false)
			this.$router.push({ name: 'specialreport' });
		},
		moreNotice() {
			sessionStorage.setItem('menuIndex', 6)
			sessionStorage.setItem('subMenuIndex', 3)
			sessionStorage.setItem('sessionFlg', true)
			sessionStorage.setItem('sessionFlg2', true)
			this.$cookie.set('showSidebarFlag', false)
			if (this.infoName.executedFile === '1') {
				// 上海
				this.$router.push({ name: 'noticedocument', query: { type: '02' } });
			} else {
				// ccsi
				this.$router.push({ name: 'hqnotice', query: { type: '02' } });
			}
		},
		moreStation() {
			sessionStorage.setItem('menuIndex', 1)
			sessionStorage.setItem('subMenuIndex', 2)
			sessionStorage.setItem('sessionFlg', true)
			sessionStorage.setItem('sessionFlg2', true)
			this.$cookie.set('showSidebarFlag', false)
			this.$router.push({ name: 'stationList', query: { type: 1 } });
		},
		moreExamination() {
			sessionStorage.setItem('menuIndex', 6)
			sessionStorage.setItem('subMenuIndex', 1)
			sessionStorage.setItem('sessionFlg', true)
			sessionStorage.setItem('sessionFlg2', true)
			this.$cookie.set('showSidebarFlag', false)
			this.$router.push({ name: 'examination' });
		},
		moreWeekly() {
			sessionStorage.setItem('menuIndex', 6)
			sessionStorage.setItem('sessionFlg', true)
			sessionStorage.setItem('sessionFlg2', true)
			this.$cookie.set('showSidebarFlag', false)
			// 判断程序文件类型后跳转至对应页面
			if (this.infoName.executedFile === '1') {
				sessionStorage.setItem('subMenuIndex', 6)
				this.$router.push({ name: 'weeklyList' });
			} else {
				sessionStorage.setItem('subMenuIndex', 5)
				this.$router.push({ name: 'projectWeekly' });
			}
		},
		moreMonthly() {
			sessionStorage.setItem('menuIndex', 6)
			sessionStorage.setItem('sessionFlg', true)
			sessionStorage.setItem('sessionFlg2', true)
			this.$cookie.set('showSidebarFlag', false)
			// 判断程序文件类型后跳转至对应页面
			if (this.infoName.executedFile === '1') {
				sessionStorage.setItem('subMenuIndex', 7)
				this.$router.push({ name: 'monthlyList' });
			} else {
				sessionStorage.setItem('subMenuIndex', 6)
				this.$router.push({ name: 'projectMonthlyList' });
			}
		},
		moreMeet() {
			sessionStorage.setItem('menuIndex', 7)
			sessionStorage.setItem('subMenuIndex', 0)
			sessionStorage.setItem('sessionFlg', true)
			sessionStorage.setItem('sessionFlg2', true)
			this.$cookie.set('showSidebarFlag', false)
			// 判断程序文件类型后跳转至对应页面
			if (this.infoName.executedFile === '1') {
				this.$router.push({ name: 'meetingList' });
			} else {
				this.$router.push({ name: 'hqmeetingList' });
			}
		},
		jumpToTemplate() {
			sessionStorage.setItem('menuIndex', 0)
			sessionStorage.setItem('subMenuIndex', 3)
			sessionStorage.setItem('sessionFlg', true)
			sessionStorage.setItem('sessionFlg2', true)
			this.$cookie.set('showSidebarFlag', false)
			this.$router.push({ name: 'fileTemplate' });
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableScnenRowClassName({ row, rowIndex });
		},
		flitterSubjectNo(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.subjectName === arr[index - 1].subjectName) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		flitterData(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.title === arr[index - 1].title) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				// this.tableData  修改
				const _row = (this.flitterSubjectNo(this.nodeList).one)[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			} else if (columnIndex === 1) {
				// this.tableData  修改
				const _row = (this.flitterData(this.nodeList).one)[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			}
		},
		getProjectFileKindList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectfilekind/list/" + $common.getItem("workNo"),
				method: 'get',
				params: this.$http.adornParams({
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.projectFilekindList = data.body.records;
					this.handoverFilePath = data.body.handoverFilePath
					this.handoverFilePathUri = data.body.handoverFilePathUri
				}
			})
		},
		getInfoName() {
			this.$http({
				url: this.$store.state.httpUrl + "/index/infoName/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.infoName = data.body;
					this.infoName.projectEntrust = this.infoName.projectEntrust.replaceAll(";", "<br/>");
					this.infoName.projectDesignCompany = this.infoName.projectDesignCompany.replaceAll(";", "<br/>");
					this.infoName.projectConstructionCompany = this.infoName.projectConstructionCompany.replaceAll(";", "<br/>");

					// this.archiveData.filingFileUri = this.infoName.filingFileUri
					// this.archiveData.filingFile = this.infoName.filingFile
					// this.archiveData.filingMan = this.infoName.filingMan
					// this.archiveData.filingTime = this.infoName.filingTime
				}
			});
		},
		// 获取连接线样式
		getConnectorClass(currentCode, nextCode) {
			const currentClass = this.getStageClass(currentCode);
			const nextClass = this.getStageClass(nextCode);

			if (currentClass === 'stage-past' && nextClass === 'stage-past') {
				return 'connector-past';
			} else if (currentClass === 'stage-past' && nextClass !== 'stage-future') {
				return 'connector-past';
			} else {
				return 'connector-future';
			}
		},
		getSimpleBlueWidth() {
			const currentStage = this.infoName.projectStep;
			if (!currentStage) return '0%';

			const stageIndex = parseInt(currentStage);
			// 灰色线 left/right 缩进通过 CSS 变量 --stage-line-padding 控制
			// 蓝色线从 left:40px(或30px) 开始，宽度 = (stageIndex/6) * (100% - 缩进量)
			return `calc((100% - var(--stage-line-padding)) * ${stageIndex} / 6)`;
		},
		// 获取阶段名称
		getStageName(stepCode) {
			const stageMap = {
				'01': '前期准备',
				'02': '建造开工准备期',
				'03': '建造期',
				'04': '交船验收期',
				'05': '质保期',
				'06': '记录与归档及移交'
			};
			return stageMap[stepCode] || '未开始';
		},
		// 获取当前阶段显示名称
		getCurrentStageName() {
			const stageMap = {
				'01': '前期阶段',
				'02': '建造开工准备阶段',
				'03': '建造期阶段',
				'04': '交船验收期阶段',
				'05': '质保期阶段',
				'06': '记录与归档及移交阶段'
			};
			return stageMap[this.selectedDisplayStep] || '';
		},
		// 获取子类样式类
		getSubclassClass(sub) {
			// 检查是否是特殊子类型
			if (this.specialSubclasscodeList.includes(sub.subclasscode)) {
				// 特殊子类型且有文件列表，显示为可点击样式
				if (sub.hasFile == 1) {
					return 'subclass-label-able';
				} else {
					// 特殊子类型但没有文件列表，显示为灰色不可点击样式
					return 'subclass-label-disabled';
				}
			} else {
				// 非特殊子类型，显示为可点击样式
				return 'subclass-label';
			}
		},
		// 获取阶段节点样式（只与infoName.projectStep有关）
		getStageClass(stageCode) {
			const currentStage = this.infoName.projectStep;
			if (!currentStage) return 'stage-future';

			const currentNum = parseInt(currentStage);
			const stageNum = parseInt(stageCode);

			if (stageNum < currentNum) {
				return 'stage-past';
			} else if (stageNum === currentNum) {
				return 'stage-current';
			} else {
				return 'stage-future';
			}
		},
		// 获取文件记录字符串
		getFileRecords(records) {
			if (!records || !records.length) return '';
			return records.map(record => record.filekindName).join('、');
		},
		// 处理阶段节点点击
		handleStageClick(stageCode) {
			this.selectedDisplayStep = stageCode;
		},
		// 处理设置按钮点击
		handleSetting() {
			this.tempProjectStep = this.infoName.projectStep;
			this.setStepVisible = true;
		},
		// 处理对话框关闭
		handleDialogClose() {
			// 重新请求infoName方法，恢复原始数据
			this.getInfoName();
		},
		saveProjectStepHandle() {
			if (this.tempProjectStep == '' || this.tempProjectStep == null) {
				this.$message.error("请选择项目当前阶段！")
				return
			}
			this.$http({
				url: this.$store.state.httpUrl + `/business/projectsupervisorinfo/updateProjectStepAndFiling`,
				method: "post",
				data: this.$http.adornData({
					workNo: $common.getItem("workNo"),
					projectStep: this.tempProjectStep,
					filingFile: this.infoName.filingFile,
					filingMan: this.infoName.filingMan,
					filingTime: this.infoName.filingTime,
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.setStepVisible = false;
							this.getInfoName();
						}
					});
				}
			});
		},
		// 处理子类点击
		handleSubclassClick(sub) {
			// 如果是特殊子类型但没有文件路径，则不处理点击事件
			if (this.specialSubclasscodeList.includes(sub.subclasscode) && sub.hasFile != 1) {
				return;
			}

			// 校验是否是系统保留的子类型，若是，直接pdf展示
			// if (this.specialSubclasscodeList.includes(sub.subclasscode)) {
			// 	this.viewPdf(sub.filePath, sub.fileUri, sub.subclassname)
			// } else 
			if (sub.subclasscode == '040105') {
				// 监理档案交接清单，显示清单列表
				this.projectHandoverVisible = true;
				this.$nextTick(() => {
					this.$refs.handoverList.init()
				})
			} else {
				// 否则展示弹窗列表
				this.subClassVisible = true;
				this.subClassTitle = sub.subclassname
				this.selectSubclasscode = sub.subclasscode
				this.getProjectFileDetailList()
			}
		},
		getCurrentTime() {
			//获取当前时间并打印
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			return yy + '-' + mm + '-' + dd;
		},
		// projectArchiveHandle() {
		// 	this.projectArchiveVisible = true;
		// 	if (this.archiveData.filingTime == '' || this.archiveData.filingTime == null) {
		// 		this.archiveData.filingTime = this.getCurrentTime()
		// 		this.archiveData.filingMan = $common.getItem("userName")
		// 	}
		// },
		// delFilingFile() {
		// 	this.archiveData.filingFile = "";
		// 	this.archiveData.filingFileUri = "";
		// },
		getProjectFileDetailList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectfiledetail/list",
				method: 'get',
				params: this.$http.adornParams({
					limit: this.pageSize,
					page: this.pageIndex,
					workNo: $common.getItem("workNo"),
					subclasscode: this.selectSubclasscode,
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.projectFileDetailList = data.body.recordList;
					this.totalPage = data.body.totalCount;
					this.pageIndex2 = this.pageIndex
				}
			})
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getProjectFileDetailList()
		},
		// 当前页
		currentChangeHandle(val) {
			if (val) {
				this.pageIndex = val
			} else {
				this.pageIndex = 1
			}
			this.getProjectFileDetailList()
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		addProjectHandOver(item) {
			const _url = "/business/projecthandoverlist/save";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					workNo: $common.getItem("workNo"),
					fileName: item.fileName,
					templatePath: item.filePath
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
				} else {
					this.$message.error(data.msg);
				}
			});
		},
		downLoadFile(fileUri, filename) {
			filename = this.getSuffix(fileUri, filename)
			this.getBlob(fileUri, (blob) => {
				this.saveAs(blob, filename)
			})
		},
		viewPdf(filePath, fileUri, filename) {
			// pdf和doc文件，需要pdf在线预览，其他类型文件直接下载
			let suffixType = fileUri.substr(fileUri.lastIndexOf(".") + 1)
			if (suffixType != '' && (suffixType === 'pdf' || suffixType === 'doc' || suffixType === 'docx')) {
				this.viewPdfVisible = true;
				this.$nextTick(() => {
					this.$refs.viewPdf.init(filename, filePath)
				})
			} else {
				filename = this.getSuffix(fileUri, filename)
				this.getBlob(fileUri, (blob) => {
					this.saveAs(blob, filename)
				})
			}
		},
		getSuffix(url, filename) {
			let lastIndex = url.lastIndexOf(".");
			return filename + url.substr(lastIndex)
		},
		getBlob(url, cb) {
			var xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (xhr.status === 200) {
					cb(xhr.response)
				}
			}
			xhr.send()
		},
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			}
			else {
				var link = document.createElement('a')
				var body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob)
				link.download = filename

				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)
				window.URL.revokeObjectURL(link.href)
			}
		},
		// uploadFilingFile(param) {
		// 	const formData = new FormData();
		// 	formData.append('file', param.file);
		// 	this.$refs.uploadFilingFile.clearFiles();
		// 	this.$http.post(
		// 		this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/92/" + '06',
		// 		formData,
		// 		{
		// 			headers: { 'Content-Type': 'multipart/form-data' }
		// 		},
		// 	).then(res => {
		// 		res = res.data;
		// 		if (res.resultCode === 200) {
		// 			this.archiveData.filingFile = res.body.fileSavePath;
		// 			this.archiveData.filingFileUri = res.body.fileUri;
		// 		} else {
		// 			this.$message.info('文件上传失败')
		// 		}
		// 	})
		// },
		// saveProjectFilingFileHandle() {
		// 	if (this.archiveData.filingMan == null || this.archiveData.filingMan == '') {
		// 		this.$message.error('请填写立卷归档人！')
		// 		return
		// 	}
		// 	if (this.archiveData.filingTime == null || this.archiveData.filingTime == '') {
		// 		this.$message.error('请填写立卷归档时间！')
		// 		return
		// 	}

		// 	this.$http({
		// 		url: this.$store.state.httpUrl + `/business/projectsupervisorinfo/updateProjectStepAndFiling`,
		// 		method: "post",
		// 		data: this.$http.adornData({
		// 			workNo: $common.getItem("workNo"),
		// 			projectStep: this.infoName.projectStep,
		// 			filingFile: this.archiveData.filingFile,
		// 			filingMan: this.archiveData.filingMan,
		// 			filingTime: this.archiveData.filingTime,
		// 		})
		// 	}).then(({ data }) => {
		// 		if (data && data.resultCode === 200) {
		// 			this.$message({
		// 				message: "操作成功",
		// 				type: "success",
		// 				duration: 1500,
		// 				onClose: () => {
		// 					this.projectArchiveVisible = false;
		// 					this.getInfoName();
		// 				}
		// 			});
		// 		}
		// 	});
		// },
		downloadTemplate() {
			var filename = '卷内目录清单模版'
			this.$http({
				url: this.$store.state.httpUrl + "/business/filetemplate/downloadTemplate",
				method: 'get',
				params: this.$http.adornParams({
					workNo: $common.getItem("workNo"),
					recno: '116'
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					filename = this.getSuffix(data.body, filename)
					this.getBlob(data.body, (blob) => {
						this.saveAs(blob, filename)
					})
				}
			})
		},
	}
}
</script>

<style lang="scss" scoped>
.hand_menu {
	color: #4a85fe;
	cursor: pointer;
}

/* 固定高度卡片 - 改为160px */
.fixed-height-card {
	height: 160px !important;
	min-height: 160px !important;
	max-height: 160px !important;
	display: flex;
	flex-direction: column;
	overflow: hidden !important;
}

/* 统一三个卡片的高度 - 改为160px */
.project-info-card,
.subject-card,
.person-card {
	height: 160px !important;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

/* 确保卡片内容区域高度固定 - 改为160px */
:deep(.project-info-card .el-card__body),
:deep(.subject-card .el-card__body),
:deep(.person-card .el-card__body) {
	flex: 1;
	height: calc(160px - 28px) !important;
	/* 总高度160px减去标题高度28px = 132px */
	min-height: 132px !important;
	max-height: 132px !important;
	padding: 8px 15px;
	overflow: hidden !important;
}

/* 固定高度的滚动内容区域 */
.fixed-scroll-content {
	height: 100% !important;
	max-height: 132px !important;
	/* 最大高度为内容区域高度 */
	overflow-y: auto !important;
	padding-right: 5px;
	box-sizing: border-box;
}

/* 标的物卡片样式 - 调整间距 */
.subject-item {
	display: flex;
	align-items: flex-start;
	margin-bottom: 8px;
	padding: 0 5px;
	line-height: 1.4;
	gap: 4px;
	/* 减少间距 */
}

/* 确保项目信息表单高度适应 */
:deep(.project-info-card .el-form) {
	height: 100% !important;
}

:deep(.project-info-card .border-form) {
	height: 100% !important;
	display: flex;
	flex-direction: column;
}

:deep(.project-info-card .el-form-item) {
	flex-shrink: 0;
}

/* 调整卡片标题 - 增加高度，字体更大 */
.card-header {
	height: 28px !important;
	/* 增加高度 */
	min-height: 28px !important;
	line-height: 28px !important;
	font-size: 15px !important;
	/* 字体比el-form大一个号 */
	font-weight: 600 !important;
	/* 增加字体粗细 */
	padding: 0 12px !important;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

/* 统一卡片头部样式 */
:deep(.el-card__header) {
	padding: 0 15px !important;
	height: 28px !important;
	/* 同步增加 */
	min-height: 28px !important;
	box-sizing: border-box;
	flex-shrink: 0 !important;
}

/* 标题文字样式 - 字体调小 */
.bd {
	font-weight: 600 !important;
	font-size: 14px !important;
	color: #00428E;
	line-height: 26px !important;
	padding: 0;
	margin: 0;
}

/* 调整项目信息表单样式 - 更紧凑 */
.compact-form {
	font-size: 13px;
	height: 100% !important;
}

/* 文本截断样式 - 超出部分省略号显示 */
.text-truncate {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	width: 100%;
	cursor: default;
}

/* 移除el-form-item的hover展开效果 */
.item::v-deep .text-truncate:hover {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.item::v-deep .el-form-item__label {
	color: #00428E !important;
	margin-right: 8px !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	white-space: nowrap !important;
	border-right: solid #dadada 1px;
	font-size: 13px;
	height: 28px;
	/* 减小高度 */
	line-height: 26px;
	padding: 0 6px;
	/* 减小内边距 */
	flex-shrink: 0;
}

::v-deep .el-form-item {
	display: flex !important;
	align-items: center !important;
	margin-bottom: 0px !important;
	min-height: 28px;
	/* 减小高度 */
	height: 28px;
	overflow: hidden;
}

::v-deep .el-form-item__content {
	line-height: 26px;
	font-size: 13px;
	color: #333;
	padding-left: 8px;
	/* 增加左侧内边距 */
	flex: 1;
	min-width: 0;
	/* 重要：防止内容撑开 */
	overflow: hidden;
}

/* 减少表单行高 */
.border-form .el-row.set_border {
	border-bottom: solid #dadada 1px;
	border-left: solid #dadada 1px;
	border-right: solid #dadada 1px;
	min-height: 28px;
	/* 减小高度 */
}

.border-form .el-row.set_border:first-child {
	border-top: solid #dadada 1px;
}

.border-form .el-row.set_border .col-set_border {
	border-right: solid #dadada 1px;
}

/* 减少表单整体高度 */
.border-form {
	margin-top: -5px;
	/* 上移表单 */
}

.project-no {
	font-weight: 500;
	color: #00428E;
	// min-width: 60px;
	/* 减少最小宽度 */
	// max-width: 80px;
	/* 减少最大宽度 */
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	flex-shrink: 0;
	display: inline-block;
	font-size: 13px;
}

.display-name {
	flex: 1;
	text-align: left;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 0;
	/* 重要：允许内容收缩 */
	font-size: 13px;
}

/* 标的物卡片中的文本截断保持悬浮展示功能 */
.subject-item .text-truncate:hover {
	overflow: visible;
	white-space: normal;
	background-color: #f8f9fa;
	position: relative;
	z-index: 10;
}

/* 项目负责人内容样式 */
.person-card .fixed-scroll-content span {
	font-size: 13px;
}

.person-card .fixed-scroll-content div {
	margin-bottom: 8px !important;
	font-size: 13px;
}

/* 标的物和项目负责人卡片的滚动区域 */
.scroll-content {
	height: 100%;
	overflow-y: auto;
	padding-right: 5px;
}

/* 自定义滚动条样式 */
.fixed-scroll-content::-webkit-scrollbar {
	width: 4px;
}

.fixed-scroll-content::-webkit-scrollbar-track {
	background: #f1f1f1;
	border-radius: 2px;
}

.fixed-scroll-content::-webkit-scrollbar-thumb {
	background: #c1c1c1;
	border-radius: 2px;
}

.fixed-scroll-content::-webkit-scrollbar-thumb:hover {
	background: #a8a8a8;
}

/* 减少卡片之间的间距 */
.el-col {
	margin-bottom: 0;
}

/* 减少表单行之间的视觉间距 */
.set_border {
	margin-bottom: 0 !important;
}







/* 工作台行样式 */
.workbench-row {
	height: 150px;
	/* 进一步减小高度，减少底部空白 */
	min-height: 150px;

	.el-col {
		height: 100%;
		display: flex;
	}
}

/* 项目相关工作card */
.project-work-card {
	height: 100%;
	flex: 1;
	display: flex;
	flex-direction: column;

	:deep(.el-card__body) {
		padding: 8px 0 2px 0 !important;
		/* 大幅减少padding，特别是底部 */
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.project-work-content {
		flex: 1;
		display: flex;
		align-items: center;
		/* 垂直居中 */
		justify-content: space-between;
		/* 水平均匀分布 */
		padding: 0 5px;

		.work-item {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			height: 100%;
			padding: 0 2px;
		}
	}
}

/* 未封闭工作card */
.unclosed-work-card {
	height: 100%;
	flex: 1;
	display: flex;
	flex-direction: column;
	margin-left: 10px;

	:deep(.el-card__body) {
		padding: 8px 0 2px 0 !important;
		/* 大幅减少padding，特别是底部 */
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.unclosed-work-content {
		flex: 1;
		display: flex;
		align-items: center;
		/* 垂直居中 */
		justify-content: space-around;
		/* 水平均匀分布 */

		.unclosed-item {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			height: 100%;
			padding: 0 5px;
		}
	}
}

.roundText {
	font-size: 13px;
	/* 字体再调小一点 */
	color: #1c1c1c;
	margin-top: 4px !important;
	/* 大幅减少上边距 */
	text-align: center;
	width: 100%;
	display: block;
	line-height: 1.2;
}

/* roundBox样式调整 - 减小尺寸，减少底部空间 */
.roundBox {
	width: 60px;
	/* 进一步减小 */
	height: 56px;
	/* 进一步减小 */
	margin: 0 auto;
	border-radius: 30px;
	/* 减小圆角半径 */
	box-shadow: 0 0 12px 0 rgb(74 133 253 / 30%);
	padding: 4px;
	/* 减小内边距 */
	box-sizing: border-box;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;

	div {
		width: 52px;
		/* 进一步减小 */
		height: 52px;
		/* 进一步减小 */
		border-radius: 26px;
		/* 减小圆角半径 */
		line-height: 52px;
		/* 调整行高 */
		text-align: center;
		font-size: 16px;
		/* 字体再调小一点 */
		color: #ffffff;
		background: linear-gradient(to right, #4a85fe 0%, #78a4ff 100%);
	}
}

.roundBox02 {
	box-shadow: 0 0 12px 0 rgb(255 185 70 / 30%);

	div {
		background: linear-gradient(to right, #ffb946 0%, #ffc86e 100%);
	}
}

.roundBox03 {
	box-shadow: 0 0 12px 0 rgb(208 97 204 / 30%);

	div {
		background: linear-gradient(to right, #78c5e4 0%, #72cfdb 100%);
	}
}

.roundBox04 {
	box-shadow: 0 0 12px 0 rgb(230 57 70 / 30%);

	div {
		background: linear-gradient(to right, #e63946 0%, #f3646f 100%);
	}
}


.roundBox05 {
	box-shadow: 0 0 12px 0 rgb(208 97 204 / 30%);

	div {
		background: linear-gradient(to right, #8ad8a8 0%, #9fdf84 100%);
	}
}

.roundBox06 {
	box-shadow: 0 0 12px 0 rgb(230 57 70 / 30%);

	div {
		background: linear-gradient(to right, #7ea3da 0%, rgb(65, 151, 231) 100%);
	}
}

.roundBox07 {
	box-shadow: 0 0 12px 0 rgb(230 57 70 / 30%);

	div {
		background: linear-gradient(to right, #da7ed2 0%, rgb(231, 65, 231) 100%);
	}
}

.el-icon-d-arrow-right {
	font-size: 18px;
	color: rgb(58, 58, 190);
	font-weight: 700;
	cursor: pointer;
}

.node-container {
	display: flex;
	color: #1c1c1c;
}

.node-left-container {
	// border: 1px #DADADA solid;
	border-right: 0px;
	width: 70px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-right: 20px;
}

.node-right-container {
	border-right: 1px #DADADA solid;
	border-bottom: 1px #DADADA solid;
	display: flex;
	flex-direction: column;
}

.node-right-container-row {
	display: flex;
}

.node-content-title1 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgb(211, 230, 248);
	height: 30px
}

.node-content-title2 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 30px
}

.node-content-title3 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgb(240, 240, 33);
	height: 30px
}

.node-content-body {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 120px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 30px
}

.node-content-body5 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 230px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 30px
}

.node-content-body1 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 120px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgb(211, 230, 248);
	height: 30px
}

.node-content-body4 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 230px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgb(211, 230, 248);
	height: 30px
}

.node-content-body3 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 120px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgb(240, 240, 33);
	height: 30px
}

.node-content-body6 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 230px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgb(240, 240, 33);
	height: 30px
}

.node-content-title-container {
	display: flex;
}

.node-content-title-container-left {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #ebeae8;
}

.node-content-title-container-right {
	display: flex;
	flex-direction: column;
}

.node-content-title-container-right-row {
	display: flex;
	flex-direction: row;
	background-color: #ebeae8;
}

/* 紧凑卡片样式 */
.compact-card {
	margin-bottom: 10px !important;
	height: auto !important;
	min-height: auto !important;

	:deep(.el-card__body) {
		padding: 10px 15px 5px 15px !important;
		/* 上右下左，下边距设为5px */
		min-height: auto !important;
		height: auto !important;
	}
}

/* 紧凑卡片头部 */
.card-header-compact {
	height: 32px !important;
	min-height: 32px !important;
	line-height: 32px !important;
	font-size: 15px !important;
	font-weight: 600 !important;
	color: #00428E;
	padding: 0 12px !important;
}

.header-content {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	/* 左对齐 */
	gap: 50px;
	/* 间距50px */
}

.header-title {
	font-weight: 600 !important;
	font-size: 15px !important;
	color: #00428E;
}

.stage-header {
	display: flex;
	align-items: center;
	gap: 8px;
}

.stage-name {
	color: #67C23A !important;
	/* 保持绿色 */
	font-weight: bold;
	font-size: 14px;
	padding: 2px 0;
	background: transparent !important;
}

.stage-setting-btn {
	padding: 4px 8px !important;
	font-size: 12px !important;
	height: 24px !important;
}

/* 统一卡片头部样式 */
:deep(.el-card__header) {
	padding: 0 15px !important;
	height: 32px !important;
	min-height: 32px !important;
	box-sizing: border-box;
}

/* 紧凑内容区域 */
.compact-content {
	margin-top: 5px;
}

/* 最后一个阶段的特殊样式 */
.last-stage-detail {
	.archiving-section {
		background: #fff;
		border-radius: 4px;
		padding: 12px;
		/* 减小内边距 */
		box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
		/* 减小阴影 */
		margin-bottom: 0;
		/* 移除底部间距 */

		.archiving-title {
			font-size: 16px;
			/* 减小字体 */
			font-weight: bold;
			color: #00428E;
			margin-bottom: 12px;
			/* 减小间距 */
			padding-bottom: 6px;
			/* 减小内边距 */
			border-bottom: 2px solid #00428E;
		}

		.archiving-content {
			.archiving-instruction {
				font-size: 13px;
				/* 减小字体 */
				color: #606266;
				margin-bottom: 15px;
				/* 减小间距 */
				padding: 10px;
				/* 减小内边距 */
				background: #f5f7fa;
				border-radius: 4px;
				border-left: 4px solid #409EFF;
			}

			.archiving-form {
				.form-row {
					display: flex;
					align-items: center;
					padding: 8px 0;
					/* 减小内边距 */

					&:last-child {
						border-bottom: none;
						padding-bottom: 0;
						/* 最后一个元素不设padding-bottom */
					}

					.form-label {
						width: 140px;
						/* 减小宽度 */
						font-weight: bold;
						color: #303133;
						font-size: 13px;
						/* 减小字体 */
					}

					.form-value {
						flex: 1;
						color: #606266;
						font-size: 13px;
						/* 减小字体 */

						.status-tag {
							display: inline-block;
							padding: 2px 8px;
							/* 减小内边距 */
							border-radius: 4px;
							font-size: 12px;
							/* 减小字体 */
							font-weight: bold;

							&.status-unarchived {
								background-color: #fef0f0;
								color: #f56c6c;
								border: 1px solid #fbc4c4;
							}
						}
					}
				}
			}
		}
	}
}

/* 所有阶段通用容器样式 - 与第六阶段保持一致 */
.archiving-section {
	background: #fff;
	border-radius: 4px;
	padding: 12px;
	/* 减小内边距 */
	box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
	/* 减小阴影 */
	margin-bottom: 0;
	/* 移除底部间距 */
	border-bottom: none;
	/* 移除底部边框 */
}

/* 紧凑的文件种类名称 */
.file-kind-name-compact {
	font-weight: bold;
	color: #303133;
	font-size: 15px !important;
	/* 减小字体 */
	height: 22px;
	/* 减小高度 */
	line-height: 22px;
	/* 行高与高度一致 */
}

/* 所有阶段文件种类行样式 */
.archiving-section .file-kind-row {
	display: flex;
	justify-content: space-between;
	margin-bottom: 6px;
	/* 减小间距 */
	padding-bottom: 4px;
	/* 减小内边距 */
	border-bottom: 1px solid #e4e7ed;
}

.archiving-section .file-records {
	color: #606266;
	font-size: 13px;
	/* 减小字体 */
}

/* 所有阶段记录行样式 */
.archiving-section .record-row {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding: 4px 0;
	/* 减小内边距 */

	&:last-child {
		padding-bottom: 0;
		/* 最后一个记录行不设padding-bottom */
	}
}

.archiving-section .record-name {
	color: #606266;
	font-weight: bold;
	font-size: 14px;
	/* 减小字体 */
	min-width: 150px;
	/* 减小宽度 */
	text-align: right;
	margin-right: 12px;
	/* 减小间距 */
}

.archiving-section .subclass-list {
	display: flex;
	flex-wrap: wrap;
	gap: 5px;
	/* 减小间距 */
	flex: 1;
	justify-content: flex-start;
}

.archiving-section .subclass-label,
.archiving-section .subclass-label-able {
	color: #66b1ff;
	cursor: pointer;
	padding: 1px 5px;
	/* 减小内边距 */
	// background: #ecf5ff;
	// border-radius: 3px;
	font-size: 11px;
	/* 减小字体 */
}

.archiving-section .subclass-label:hover {
	background: #409EFF;
	color: white;
}

/* 原始阶段内容样式 */
.stage-content {
	margin-bottom: 0;
	/* 移除底部间距 */
	border-radius: 4px;
	padding-bottom: 0;
	/* 移除底部内边距 */
	border: none;
	/* 确保无边框 */
}

.stage-content .file-kind-row {
	display: flex;
	justify-content: space-between;
	margin-bottom: 6px;
	/* 减小间距 */
	padding-bottom: 4px;
	/* 减小内边距 */
	border-bottom: 1px solid #e4e7ed;
}

.stage-content .file-kind-row .file-records {
	color: #606266;
	font-size: 13px;
	/* 减小字体 */
}

.stage-content .record-row {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding: 4px 0;
	/* 减小内边距 */

	&:last-child {
		padding-bottom: 0;
	}
}

.stage-content .record-row .subclass-list {
	display: flex;
	flex-wrap: wrap;
	gap: 5px;
	/* 减小间距 */
	flex: 1;
	justify-content: flex-start;
}

.stage-content .record-row .subclass-label {
	color: #66b1ff;
	cursor: pointer;
	padding: 1px 5px;
	/* 减小内边距 */
	// background: #ecf5ff;
	border-radius: 3px;
	font-size: 13px;
	/* 减小字体 */
}

.stage-content .record-row .subclass-label:hover {
	background: #409EFF;
	color: white;
}

.stage-content .record-row .subclass-label-able {
	color: #5b6fd4;
	cursor: pointer;
	padding: 1px 5px;
	/* 减小内边距 */
	// background: #ecf5ff;
	border-radius: 3px;
	font-size: 13px;
	/* 减小字体 */
}

.stage-content .record-row .subclass-label-able:hover {
	background: #5b6fd4;
	color: white;
}

.majTitle1 {
	background-color: #E1F1FF;
	padding-left: 15px;
	font-weight: bolder;
	color: #00428e !important;
	height: 35px;
	/* 减小高度 */
	padding-top: 9px;
	/* 调整内边距 */
}

::v-deep(.upload-demo .el-upload-dragger) {
	margin-top: 20px;
	width: 600px;
	height: 120px;
}

::v-deep(.upload-demo .el-upload-dragger .el-icon-upload) {
	font-size: 30px;
	margin: 20px 1px;
	line-height: 20px;
}

::v-deep(.upload-demo .el-upload-dragger .el-upload__text) {
	line-height: 5px;
}

.upload-header {
	background-color: #e1f1ff;
	padding: 7px 18px;
	color: #00428e;
}

/* 如果上面的选择器不生效，可以使用更具体的选择器 */
:deep(.el-date-editor.el-input) .el-input__inner,
:deep(.custom-input .el-input__inner) {
	height: 32px !important;
	line-height: 32px !important;
	border-radius: 0 !important;
}

::v-deep(.selSubjectInput .el-input__inner) {
	width: 200px !important;
	height: 35px !important;
}

.subclass-label-disabled {
	color: #c0c4cc;
	cursor: default;
	padding: 1px 5px;
	/* 减小内边距 */
	// background: #f5f7fa;
	border-radius: 3px;
	font-size: 13px;
	/* 减小字体 */
}

/* 确保子类列表中的样式正确应用 */
.archiving-section .subclass-list {
	display: flex;
	flex-wrap: wrap;
	gap: 5px;
	/* 减小间距 */
	flex: 1;
	justify-content: flex-start;
}

.stage-content .record-row .subclass-list {
	display: flex;
	flex-wrap: wrap;
	gap: 5px;
	/* 减小间距 */
	flex: 1;
	justify-content: flex-start;
}

/* 减少整体页面的底部边距 */
.mod-config {
	padding-bottom: 0 !important;
	margin-bottom: 0 !important;
}

.el-row {
	margin-bottom: 0 !important;
}

/* 确保卡片底部无空白 */
:deep(.el-card) {
	overflow: hidden;
}

/* 移除所有可能导致底部空白的padding和margin */
.compact-content {
	padding-bottom: 0 !important;
}


/* 阶段进度条容器 */
.stage-progress-container {
	position: relative;
	width: 100%;
	height: 60px;
	/* 紧凑高度 */
	margin: 0;
	padding: 0;
	/* 灰色线总缩进量（left:40px + right:40px = 80px），供蓝色线宽度计算使用 */
	--stage-line-padding: 80px;
}

/* 灰色背景线 */
.grey-background-line {
	position: absolute;
	top: 15px;
	left: 40px;
	right: 40px;
	height: 2px;
	/* 细的灰色背景线 */
	background-color: #e4e7ed;
	z-index: 1;
}

/* 蓝色进度线 */
.blue-progress-line {
	position: absolute;
	top: 14px;
	left: 40px;
	height: 4px;
	background: #409EFF;
	z-index: 2;
	transition: width 0.5s ease;
	border-radius: 2px;
}

/* 连接线 - 仅在有进度时显示对应颜色，否则不显示（由灰色背景线承担连接） */
.connector {
	display: none;
}

.connector.connector-past {
	display: block;
	position: absolute;
	top: 15px;
	left: calc(50% + 14px);
	width: calc(50% - 28px);
	height: 2px;
	background: #409EFF;
	z-index: 2;
	pointer-events: none;
}

.stage-node:last-child .connector {
	display: none;
}

/* 阶段节点容器 */
.stage-progress {
	display: flex;
	justify-content: space-between;
	position: relative;
	width: 100%;
	height: 100%;
	z-index: 3;
	/* 确保在进度条上面 */
}

/* 阶段节点 */
.stage-node {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: calc(100% / 6);
	cursor: pointer;
	position: relative;
	padding: 0 2px;

	&:hover {
		.marker-circle {
			transform: scale(1.1);
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		}

		.node-label {
			color: #00428E;
			font-weight: 600;
		}
	}
}

/* 节点标记容器 */
.node-marker {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 30px;
	margin-bottom: 4px;
}

/* 圆形标记 - 保持原样 */
.marker-circle {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	font-weight: 600;
	transition: all 0.3s ease;
	position: relative;
	z-index: 4;
	/* 确保在最上面 */

	&.stage-past {
		background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
		color: white;
		box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);

		.icon-check {
			width: 14px;
			height: 14px;
		}
	}

	&.stage-current {
		background: linear-gradient(135deg, #67C23A 0%, #85ce61 100%);
		/* 保持绿色渐变 */
		color: white;
		box-shadow: 0 2px 10px rgba(103, 194, 58, 0.4);
		animation: pulse 2s infinite;

		&::after {
			content: '';
			position: absolute;
			top: -4px;
			left: -4px;
			right: -4px;
			bottom: -4px;
			border-radius: 50%;
			border: 2px solid rgba(103, 194, 58, 0.2);
			/* 保持绿色 */
			animation: pulse-ring 2s infinite;
			z-index: 1;
		}
	}

	&.stage-future {
		background: white;
		color: #909399;
		border: 2px solid #dcdfe6;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
	}
}

.marker-number {
	font-size: 12px;
	font-weight: 600;
}

/* 节点标签 */
.node-label {
	font-size: 11px;
	color: #606266;
	text-align: center;
	line-height: 1.2;
	max-width: 120px;
	word-wrap: break-word;
	transition: all 0.3s ease;

	&.stage-past {
		color: #409EFF;
		/* 改为蓝色 */
		font-weight: 500;
	}

	&.stage-current {
		color: #67C23A;
		/* 保持绿色 */
		font-weight: 600;
	}

	&.stage-future {
		color: #909399;
	}
}

/* 动画效果 */
@keyframes pulse {
	0% {
		transform: scale(1);
		box-shadow: 0 2px 10px rgba(103, 194, 58, 0.4);
	}

	50% {
		transform: scale(1.05);
		box-shadow: 0 4px 16px rgba(103, 194, 58, 0.6);
	}

	100% {
		transform: scale(1);
		box-shadow: 0 2px 10px rgba(103, 194, 58, 0.4);
	}
}

@keyframes pulse-ring {
	0% {
		transform: scale(1);
		opacity: 1;
	}

	100% {
		transform: scale(1.3);
		opacity: 0;
	}
}

/* 响应式调整 */
@media (max-width: 1200px) {
	.stage-progress-container {
		height: 55px;
	}

	.grey-background-line {
		top: 14px;
	}

	.blue-progress-line {
		top: 13px;
	}

	/* 1200px断点：圆直径26px，半宽13px */
	.connector.connector-past {
		top: 14px;
		left: calc(50% + 13px);
		width: calc(50% - 26px);
	}

	.node-label {
		font-size: 10px;
		max-width: 70px;
	}

	.marker-circle {
		width: 26px;
		height: 26px;

		.marker-number {
			font-size: 11px;
		}

		.icon-check {
			width: 13px;
			height: 13px;
		}
	}
}

@media (max-width: 768px) {
	.stage-progress-container {
		height: 50px;
		/* 移动端灰色线缩进为 left:30px + right:30px = 60px */
		--stage-line-padding: 60px;
	}

	.grey-background-line {
		top: 12px;
		left: 30px;
		right: 30px;
	}

	.blue-progress-line {
		top: 11px;
		left: 30px;
	}

	/* 移动端：圆直径24px，半宽12px */
	.connector.connector-past {
		top: 12px;
		left: calc(50% + 12px);
		width: calc(50% - 24px);
	}

	.node-label {
		font-size: 9px;
		max-width: 60px;
	}

	.marker-circle {
		width: 24px;
		height: 24px;

		.marker-number {
			font-size: 10px;
		}

		.icon-check {
			width: 12px;
			height: 12px;
		}
	}
}

/* 紧凑内容区域 */
.compact-content {
	margin-top: 5px;
}




/* 紧凑对话框样式 */
.compact-dialog {
	:deep(.el-dialog) {
		/* 固定对话框总高度 */
		height: 660px !important;
		max-height: 660px !important;
		min-height: 660px !important;
		/* 固定宽度800px */
		width: 700px !important;

		/* 让对话框垂直居中显示 */
		position: absolute !important;
		top: 50% !important;
		left: 50% !important;
		transform: translate(-50%, -50%) !important;
		margin: 0 !important;

		/* 确保对话框不会超出屏幕 */
		overflow: hidden !important;
		display: flex !important;
		flex-direction: column !important;
	}

	:deep(.el-dialog__header) {
		padding: 8px 20px !important;
		height: 36px !important;
		min-height: 36px !important;
		flex-shrink: 0;
		box-sizing: border-box;
		border-bottom: 1px solid #e4e7ed !important;

		.el-dialog__title {
			font-size: 15px !important;
			line-height: 20px !important;
		}

		.el-dialog__headerbtn {
			top: 8px !important;
			font-size: 14px !important;
			height: 20px !important;
			width: 20px !important;

			.el-icon-close {
				font-size: 14px !important;
			}
		}
	}

	:deep(.el-dialog__body) {
		flex: 1 !important;
		padding: 5px 20px 0px 20px !important;
		overflow: hidden !important;
		display: flex !important;
		flex-direction: column !important;
		height: calc(100% - 36px) !important;
		min-height: 0 !important;
		box-sizing: border-box !important;
	}

	:deep(.el-dialog__footer) {
		display: none !important;
	}
}

.compact-dialog .dialog-content .dataListTable :deep(.el-table) {
	position: static !important;
}

/* 对话框内容区域 */
.dialog-content {
	flex: 1 !important;
	display: flex !important;
	flex-direction: column !important;
	height: 100% !important;
	min-height: 0 !important;
	margin: 0 !important;
	padding: 0 !important;

	/* 表格区域 */
	.dataListTable {
		flex: 1 !important;
		min-height: 0 !important;
		height: calc(100% - 44px) !important;
		/* 调整：100% - 分页高度(24px) - 上下margin(20px) */
		overflow: hidden !important;

		:deep(.el-table) {
			height: 100% !important;

			.el-table__body-wrapper {
				overflow-y: auto !important;
			}

			.el-table__empty-block {
				min-height: 520px !important;
				height: 520px !important;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		:deep(.el-table__row) {
			height: 28px !important;
		}

		:deep(.el-table__header) {
			th {
				font-size: 11px !important;
				padding: 4px 0 !important;
				height: 28px !important;
				font-weight: 600;
			}
		}

		:deep(.el-table__body) {
			td {
				font-size: 11px !important;
				padding: 2px 0 !important;
				line-height: 1.2;
			}
		}

		:deep(.el-button--text) {
			font-size: 11px !important;
			padding: 0 4px !important;
		}

		:deep(.el-table__cell) {
			padding: 0 !important;

			.cell {
				padding: 2px 0 !important;
				line-height: 1.2;
			}
		}
	}

	/* 分页组件 - 增加上下margin */
	.my-pagination {
		flex-shrink: 0 !important;
		height: 24px !important;
		min-height: 24px !important;
		max-height: 24px !important;
		width: 100% !important;
		display: flex !important;
		justify-content: flex-end !important;
		align-items: center !important;
		padding: 0 !important;
		margin: 10px 0 10px 0 !important;
		/* 上下margin各10px */
		box-sizing: border-box !important;

		/* 分页样式 */
		:deep(.el-pagination) {
			height: 24px !important;
			min-height: 24px !important;
			max-height: 24px !important;
			padding: 0 !important;
			margin: 0 !important;
			line-height: 24px !important;

			.el-pagination__total,
			.el-pagination__sizes,
			.el-pagination__jump,
			.el-pagination__editor {
				font-size: 10px !important;
				height: 22px !important;
				line-height: 22px !important;
				margin: 0 !important;
				padding: 0 !important;
			}

			.el-pagination__total {
				margin-right: 4px !important;
			}

			.el-pagination__sizes {
				margin: 0 4px 0 0 !important;

				.el-input {
					height: 22px !important;
					line-height: 22px !important;

					.el-input__inner {
						height: 22px !important;
						line-height: 22px !important;
						font-size: 10px !important;
						padding: 0 4px !important;
						border-radius: 2px !important;
					}
				}
			}

			.btn-prev,
			.btn-next {
				height: 22px !important;
				width: 22px !important;
				min-width: 22px !important;
				line-height: 22px !important;
				margin: 0 1px !important;
				padding: 0 !important;
				font-size: 10px !important;
				border-radius: 2px !important;
			}

			.el-pager {
				height: 22px !important;
				line-height: 22px !important;
				margin: 0 !important;
				padding: 0 !important;

				li {
					height: 22px !important;
					line-height: 22px !important;
					min-width: 22px !important;
					margin: 0 1px !important;
					padding: 0 !important;
					font-size: 10px !important;
					border-radius: 2px !important;
				}
			}

			.el-pagination__jump {
				margin-left: 4px !important;

				.el-input {
					height: 22px !important;
					line-height: 22px !important;

					.el-input__inner {
						height: 22px !important;
						line-height: 22px !important;
						font-size: 10px !important;
						padding: 0 4px !important;
						width: 35px !important;
						border-radius: 2px !important;
					}
				}
			}
		}
	}
}
</style>